import { Allow, IsDefined, IsIn, IsInt, IsISO8601, IsOptional, IsString } from 'class-validator';
import { CountTimes } from '../../enum';

export class GetCashUpBatchDto {
  @IsOptional()
  @IsInt()
  posDeviceId: number;

  @IsOptional()
  @IsInt()
  sweetFaceTerminalId: number;

  @IsDefined()
  @IsInt()
  merchantId: number;

  @IsDefined()
  @IsInt()
  currencyId: number;

  @IsDefined()
  @IsInt()
  countedTimes: number;

  @IsOptional()
  @IsString()
  @Allow(null)
  @IsIn(Object.values(CountTimes))
  countedWhen: string;

  @IsDefined()
  @IsISO8601()
  day: string;

  @IsDefined()
  @IsString()
  type: string;

  @IsOptional()
  @IsInt()
  merchantServiceTimeId: number;
}